import { render } from "./FontPicker.vue?vue&type=template&id=60f59a0f"
import script from "./FontPicker.vue?vue&type=script&lang=js"
export * from "./FontPicker.vue?vue&type=script&lang=js"

import "./FontPicker.vue?vue&type=style&index=0&id=60f59a0f&lang=postcss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__